<div class="policy-page">
  <div class="policy-container">
    <h1>TERMS OF SERVICE</h1>

    <p class="brand-name"><strong>Pixie Pets</strong></p>
    <p class="last-updated"><em>Last updated: 22.12.2025</em></p>

    <hr>

    <h2>1. Introduction</h2>
    <p>Welcome to Pixie Pets.</p>
    <p>Pixie Pets allows users to turn pet photos into custom artwork and order personalized physical products such as apparel, home decor, and accessories.</p>
    <p>By using our website and services, you agree to these Terms of Service.</p>

    <hr>

    <h2>2. Company Information</h2>
    <p>Pixie Pets is operated by:</p>
    <p><strong>Team Up Recruitment sp. z o.o.</strong><br>
    ul. Sienkiewicza 72<br>
    90-318 Łódź<br>
    Poland<br>
    VAT ID: PL7252288257</p>

    <hr>

    <h2>3. Creating and Ordering Products</h2>
    <ul>
      <li>You upload a photo of your pet and select a style and product.</li>
      <li>You can preview your design before placing an order.</li>
      <li>All products are made to order and personalized.</li>
      <li>Once production begins, orders cannot be changed or cancelled.</li>
    </ul>

    <hr>

    <h2>4. Quality Review</h2>
    <p>Before printing, orders may be reviewed to ensure proper placement, appearance, and print quality.</p>
    <p>If clarification or adjustment is needed, we may contact you before production to confirm changes.</p>

    <hr>

    <h2>5. Production, Shipping & Delivery</h2>
    <ul>
      <li>Products are produced and shipped by our fulfillment partners.</li>
      <li>Production typically takes <strong>2–5 business days</strong>.</li>
      <li>Shipping times depend on destination and carrier.</li>
    </ul>
    <p>Pixie Pets is not responsible for delays caused by shipping carriers, customs, or factors beyond our control.</p>

    <hr>

    <h2>6. Returns & Refunds (Summary)</h2>
    <p>Because all Pixie Pets products are personalized and made to order, returns and refunds are handled according to our <strong>Returns Policy</strong>, available on a dedicated page.</p>
    <p>Please review the Returns Policy carefully before placing an order.</p>

    <hr>

    <h2>7. User Content & Intellectual Property</h2>
    <p>You confirm that:</p>
    <ul>
      <li>you own the rights to the photos you upload, or</li>
      <li>you have permission to use them.</li>
    </ul>
    <p>You are responsible for ensuring uploaded content does not infringe third-party rights.</p>
    <p>Pixie Pets is not responsible for intellectual property violations related to user-submitted content.</p>
    <p>You grant Pixie Pets permission to use uploaded content solely to create and fulfill your order.</p>

    <hr>

    <h2>8. Limitation of Liability</h2>
    <p>Pixie Pets is not liable for indirect, incidental, or consequential damages related to the use of our services or products.</p>
    <p>Our total liability is limited to the amount paid for the order in question.</p>

    <hr>

    <h2>9. Changes to These Terms</h2>
    <p>We may update these Terms from time to time.<br>
    The latest version will always be available on our website.</p>

    <hr>

    <h2>10. Contact</h2>
    <p>For questions regarding these Terms, contact us at:<br>
    <a [href]="'mailto:' + supportEmail"><strong>{{ supportEmail }}</strong></a></p>
  </div>
</div>
